import { all, fork } from 'redux-saga/effects';
import { getGroupNameSaga } from './get-group-name';
import { getGroupsSaga } from './get-groups';
export function* rootSaga() {
    yield all([fork(getGroupNameSaga), fork(getGroupsSaga)]);
}
